import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import VoucherForm from './forms/VoucherForm';
import VoucherList from './lists/VoucherList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {paramsSerializer, postData} from "../../utils/request";
import Modal from "../layout/Modal";
import TextInput from "../form/TextInput";
import { saveAs } from 'file-saver';
import DateTimeInput from "../form/DateTimeInput";
import RadioGroup from "../form/RadioGroup";

class Export extends React.Component {

    state = {
        opened: false,
        generate: {
            'export': 'sold'
        }
    };

    export = () => {
        const params = {...this.state.generate};
        params.resptype = "excel";
        params.option = this.props.componentConfig.componentname;
        window.open("index.php?" + paramsSerializer(params), "_blank");
    }

    render() {
        return (
            <Fragment>
                <Modal
                    state={this.state.opened}
                    header="Export"
                    buttons={[
                        {
                            text: "Mégse",
                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: () => {
                                this.setState({opened: false});
                            }
                        },
                        {
                            icon: {lib: "far", name: "file-excel"},
                            text: "Export",
                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                            onClick: this.export
                        }
                    ]}
                >

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <RadioGroup
                                    name="export"
                                    labelKey="label"
                                    valueKey="value"
                                    objectValue={false}
                                    options={[{value: "sold", label: "Eladott utalványok"},{value: "redeemed", label: "Beváltott utalványok"}]}
                                    value={this.state.generate.export}
                                    label={false}
                                    saveChanges={(field, type) => {
                                        this.setState({generate: {...this.state.generate, 'export': type}});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <DateTimeInput
                                    label={false}
                                    isClearable={true}
                                    placeholder="Dátumtól"
                                    maxDate={this.state.generate.to}
                                    value={this.state.generate.from}
                                    saveChanges={(field, from) => {
                                        this.setState({generate: {...this.state.generate, from}});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <DateTimeInput
                                    label={false}
                                    isClearable={true}
                                    placeholder="Dátumig, alapértelmezett: mai napig"
                                    minDate={this.state.generate.from}
                                    value={this.state.generate.to}
                                    saveChanges={(field, to) => {
                                        this.setState({generate: {...this.state.generate, to}});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="default"
                    onClick={() => this.setState({opened: true})}
                    icon={{lib: "far", name: "file-excel"}}
                >
                    Export
                </Button>
            </Fragment>
        );
    }
}

class VoucherEditor extends React.Component {

    state = {
        generate: null,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    generateVouchers = async () => {
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.generateVouchers',
                ...this.state.generate
            });
            if (response instanceof Blob) {
                saveAs(response, response.filename);
            }
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            this.setState({generate: null});
            return response;
        });
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Utalványok"
                    footer={[
                        /*<Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>,*/
                        <Export key="9" {...this.props}/>,
                        <Fragment key="1">
                            {this.state.generate !== null && <Modal
                                state="on"
                                header="Generálás"
                                buttons={[
                                    {
                                        text: "Mégse",
                                        props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                        onClose: true,
                                        onClick: () => {
                                            this.setState({generate: null});
                                        }
                                    },
                                    {
                                        text: "Mehet",
                                        props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                        onClick: this.generateVouchers
                                    }
                                ]}
                            >
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <TextInput
                                                label="Darab"
                                                type="number"
                                                value={this.state.generate.qty}
                                                saveChanges={(field, qty) => {
                                                    this.setState({generate: {...this.state.generate, qty}});
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <TextInput
                                                label="Érték"
                                                type="number"
                                                value={this.state.generate.voucher_value}
                                                saveChanges={(field, voucher_value) => {
                                                    this.setState({generate: {...this.state.generate, voucher_value}});
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Modal>}
                            <Button
                                key="0"
                                disabled={this.props.isLoading}
                                color="primary"
                                onClick={() => this.setState({generate: {}})}
                            >
                                Generálás
                            </Button>
                        </Fragment>
                    ]}
                >
                    <VoucherList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Utalvány"
                    footer={[
                        /*<Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>*/
                    ]}
                >
                    <VoucherForm {...this.props} />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "Voucher",
    WrappedComponent: VoucherEditor
});
